import React, { useState, useEffect } from 'react';
import LiveChat from './LiveChat';
import Icon from './Icon';

const PAINS = [
  "reply to the 11pm message before the prospect moves on.",
  "juggle 50 conversations without letting a single one go cold.",
  "follow up with every prospect at the right time, missing none.",
  "watch Instagram, WhatsApp, LinkedIn and email all at once.",
  "filter out the tire-kickers before blocking 30 minutes for a call.",
  "stay reachable at night, on weekends, and during holidays.",
];

function Hero() {
  const [idx, setIdx] = useState(0);
  const [swap, setSwap] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setSwap(true);
      setTimeout(() => {
        setIdx(prev => (prev + 1) % PAINS.length);
        setSwap(false);
      }, 360);
    }, 2600);
    return () => clearInterval(interval);
  }, []);

  return (
    <header className="hero">
      <div className="wrap">
        <div className="hero-grid">
          <div>
            <span className="kicker"><span className="pulse"></span>AI sales operator · live on this page</span>
            <h1>
              Your sales team knows how to sell.<br />
              But they're asked to do the impossible:<br />
              <span className={`hl pain-rotator${swap ? ' swap' : ''}`}>{PAINS[idx]}</span>
            </h1>
            <p className="sub">
              Salesyo is the AI sales operator that absorbs everything draining your team: instant replies,
              follow-ups, filtering out tire-kickers. Then it hands them conversations that are ready to close.
              Across 10 centralized channels, 24/7. Writing like a human who knows how to sell.
            </p>
            <div className="try-hint"><span className="arrow"><Icon name="arrowRight" /></span> This assistant is Salesyo. Ask it anything. It answers live.</div>
            <div className="hero-cta">
              <a href="https://calendly.com/salesyo-ai/30min" target="_blank" rel="noopener noreferrer" className="btn btn-wa">Book a free demo</a>
              <a href="#cycle" className="btn btn-ghost">See the full cycle</a>
            </div>
            <p className="micro">No credit card · 30-minute demo · 10 centralized channels</p>
            <div className="trust">
              <span className="badge"><span className="ic"><Icon name="check" /></span>Meta Business Partner</span>
              <span className="badge"><span className="ic"><Icon name="check" /></span>GDPR compliant</span>
              <span className="badge"><span className="ic"><Icon name="check" /></span>Hosted in the EU</span>
            </div>
          </div>
          <div>
            <LiveChat />
          </div>
        </div>
      </div>
    </header>
  );
}

export default Hero;
